import {
  Box,
  BoxProps,
  ColorOptions,
  IconButton,
  ModBox,
  SpacerNew,
  Text,
  TextNew,
  TextNewProps,
  TextProps,
} from '@jfs/ui-new'
import { ButtonNew } from '../../../components/AdminButton'
import { useCallback } from 'react'
import { Colors } from '../../../utils'

interface EntityOnboardingHeaderProps {
  title: string
  applicationId?: string
  entityId?: any
  applicationStatus?: string
  onboardingChannel?: string
  showBackButton?: any
  toggleEdit?: any
  editable?: boolean
  showEditButton?: any
  onBackPress?: any
  showEditAsMaker?: any
  isEditAsMakerEditable?: any
  onEditAsMakerPress?: any
  requestType?: any
  businessChannel?: any
  entityStatus?: any
}

export const EntityOnboardingHeader = ({
  title,
  applicationId,
  applicationStatus,
  onboardingChannel,
  showBackButton = false,
  toggleEdit,
  editable,
  showEditButton = false,
  showEditAsMaker = false,
  onBackPress,
  entityId,
  isEditAsMakerEditable = false,
  onEditAsMakerPress,
  requestType,
  businessChannel,
  entityStatus,
}: EntityOnboardingHeaderProps) => {
  const getStatusColor = useCallback(
    (type: 'BG' | 'TEXT'): any => {
      if (['APPROVED'].includes(applicationStatus)) {
        return type === 'BG' ? Colors.GREEN_BG_C : Colors.GREEN_C
      } else if (
        [
          'OPS_CHECKER_ONE',
          'OPS_CHECKER_TWO',
          'OPS_HOLD',
          'OPS_MAKER_REWORK',
          'RISK_REFER',
          'RISK_MAKER',
          'RISK_CHECKER_ONE',
          'RISK_APPROVED',
          'FULFILLMENT',
          'COMPLETED',
        ].includes(applicationStatus)
      ) {
        return type === 'BG' ? Colors.ORANGE_BG_C : Colors.ORANGE_C
      } else if (['AML_REJECT', 'DEDUPE_REJECT', 'RISK_REJECT', 'RISK_HOLD'].includes(applicationStatus)) {
        return type === 'BG' ? Colors.RED_BG_C : Colors.RED_C
      }
      return type === 'BG' ? 'BRAND_COLOR_GRAY_3' : 'BRAND_COLOR_GRAY_1'
    },
    [applicationStatus],
  )

  return (
    <Box {...styles.container}>
      <ModBox show={showBackButton}>
        <IconButton id="ARROW_LEFT" color="PRIMARY" onPress={onBackPress} size={32} />
      </ModBox>
      <Box flexDirection={'column'} flex={1}>
        <Box flexDirection={'row'} alignItems={'center'}>
          <Text {...styles.titleText}>{title}</Text>
          <SpacerNew size={20} direction="horizontal" />
          {applicationStatus && (
            <Box {...styles.statusContainer(getStatusColor('BG'))}>
              <TextNew {...styles.labelStyle(getStatusColor('TEXT'))}>{applicationStatus}</TextNew>
            </Box>
          )}
        </Box>
        <Box>
          <Box flexDirection={'row'} justifyContent={'flex-start'} width={'100%'}>
            <TitleDetailTextView title="Application Id" detail={applicationId} />
            <TitleDetailTextView title="Entity Id" detail={entityId} />
            <TitleDetailTextView title="OnBoarding Channel" detail={onboardingChannel} />
          </Box>
          <Box flexDirection={'row'} justifyContent={'flex-start'} width={'100%'}>
            <TitleDetailTextView title="Request Type" detail={requestType} />
            <TitleDetailTextView title="Business Channel" detail={businessChannel} />
            <TitleDetailTextView title="Entity Status" detail={entityStatus} />
          </Box>
        </Box>
      </Box>
      <ModBox show={showEditAsMaker} mr={20}>
        <ButtonNew
          height={32}
          color="PRIMARY"
          width={200}
          type={'primaryIcon'}
          disabled={editable}
          title={isEditAsMakerEditable ? 'Cancel as Maker' : 'Edit as Maker'}
          icon={isEditAsMakerEditable ? 'CLEAR' : 'EDIT'}
          onPress={onEditAsMakerPress}
        />
      </ModBox>

      <ModBox show={showEditButton}>
        <ButtonNew
          height={32}
          color="PRIMARY"
          width={200}
          type={'primaryIcon'}
          disabled={isEditAsMakerEditable}
          title={editable ? 'Cancel' : 'Edit'}
          icon={editable ? 'CLEAR' : 'EDIT'}
          onPress={toggleEdit}
        />
      </ModBox>
    </Box>
  )
}

const styles = {
  container: {
    paddingHorizontal: 16,
    minHeight: 72,
    borderBottomWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
    pv: 12,
    borderBottomColor: 'BORDER_COLOR',
  } as BoxProps,
  titleText: {
    fontSize: 16,
    fontFamily: 'jioType-bold',
    color: 'BLACK_21',
  } as TextProps,
  statusContainer: (bgColor: ColorOptions) =>
    ({
      justify: 'center',
      align: 'center',
      borderRadius: 8,
      pv: 4,
      ph: 16,
      bg: bgColor,
    } as BoxProps),
  labelStyle: (color: ColorOptions) =>
    ({
      type: 'body12',
      fontWeight: 'MEDIUM',
      color: color,
    } as TextNewProps),
}

const TitleDetailTextView = ({ title, detail }: any) => {
  return (
    <ModBox
      backgroundColor={'#F0F0F0' as ColorOptions}
      borderRadius={4}
      paddingVertical={4}
      paddingHorizontal={16}
      marginVertical={8}
      borderWidth={1}
      borderColor={'BORDER_COLOR'}
      flexDirection={'row'}
      alignSelf={'flex-start'}
      show={detail?.length > 0 && detail !== 'NA'}
      marginRight={24}>
      <Text title={`${title} : `} color={'BLACK_75'} fontSize={12} fontFamily={'jiotype-medium'} />
      <Text title={detail} color={'BLACK_21'} fontSize={12} fontFamily={'jiotype-bold'} />
    </ModBox>
  )
}
